module.exports = __webpack_public_path__ + "img/chevron-right.57e337ba.svg";